import { Button, Col, Form, Row, Space, Spin, message } from "antd";
import { InputFields } from "components/common";
import React, { useEffect, useRef, useState } from "react";
import { dataFields } from "./ModalAction.config";
// import {glassStoreService} from "api";
import { employeeService } from "api";
import Notification from "components/common/notification/notification";
import dayjs from "dayjs";
import { create } from "domain";
import { fields } from "pages/Pay/PendingTab/data.config";
import { RangePickerProps } from "antd/es/date-picker";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getKyLuat, getListCa } from "redux/reducer/employee";
const ModalAction = (props) => {
  const { data, closeModal, type, getListStore } = props;
  // console.log("áasd",getListStore);
  // console.log("áasd",type);
  const [loading, setLoading] = useState(false);
 const dataField = dataFields()
 const employees = useAppSelector(
  (state) => state.employeesReducer
);
const dispatch = useAppDispatch();
  const [field,setField] = useState(dataFields(onChangeCheck));

  
  const [form] = Form.useForm();
  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);
  // useEffect(() => {
  //   dispatch(getListCa({
  //     page: 1,
  //     limit: 100,
  //   }));    
  //   }, []);
  //   useEffect(() => {
  //     setOptionsKLFields(employees.listCa, "chamCongTuongUng");
  //   }, [employees.listCa]);   
  //   const setOptionsKLFields = (list, hoTen) => {
  //     if (field.find((field) => field.name === hoTen)) {
  //       field.find((field) => field.name === hoTen).options =
  //         list?.map((item) => ({
  //           value: item.id,
  //           label: item.kyhieu,
  //           key: `${item.id}-${item.kyHieu}`,
  //         }));
  //         setField([...field]);
  //     }
  //   };
  //Thêm mới
  const addStore = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        thoiGianBatDau: value?.thoiGianBatDau?.format("HH:mm:ss"),
        thoiGianKetThuc: value?.thoiGianKetThuc?.format("HH:mm:ss"),
        thoiGianTinhGioDiMuon: value?.thoiGianTinhGioDiMuon?.format("HH:mm:ss"),
        thoiGianVaoLamTu: value?.thoiGianVaoLamTu?.format("HH:mm:ss"),
        thoiGianVaoLamDen: value?.thoiGianVaoLamDen?.format("HH:mm:ss"),
      };
      const res = await employeeService.editShiftWorkSetting(params);
      if (res.code === 400) {
        Notification("error", res.message);
      } else {
        Notification("success", `Đã thêm mới ca làm việc thành công  `);
        form.resetFields();
      }
      setLoading(false);
      await getListStore();
      closeModal();
    } catch (error) {
      setLoading(false);
      Notification("error", `Đã có lỗi khi thêm mới ca làm việc `);
    }
  };
  //Sửa
  const updateStore = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id: data.id,
       // chamCongTuongUng: value?.chamCongTuongUng,
        thoiGianBatDau: value?.thoiGianBatDau?.format("HH:mm:ss"),
        thoiGianKetThuc: value?.thoiGianKetThuc?.format("HH:mm:ss"),
        thoiGianTinhGioDiMuon: value?.thoiGianTinhGioDiMuon?.format("HH:mm:ss"),
        thoiGianVaoLamTu: value?.thoiGianVaoLamTu?.format("HH:mm:ss"),
        thoiGianVaoLamDen: value?.thoiGianVaoLamDen?.format("HH:mm:ss"),
      };
      const res = await employeeService.editShiftWorkSetting(params);
      if (res.code === 400) {
        Notification("error", res.message);
      } else {
        Notification("success", `Đã chỉnh sửa ca làm việc thành công  `);
      }
      setLoading(false);
      await getListStore();
      closeModal();
    } catch (error) {
      setLoading(false);
      Notification("error", `Đã có lỗi khi sửa ca làm việc `);
    }
  };
  useEffect(() => {
    if(data !== null)
    {
      if(data.loaiCaLam === 0) {
        field.map((e) => {
          if (e.name === "thoiGianBatDau") {
            e.hide = false;
            e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
          }
          if (e.name === "thoiGianTinhGioDiMuon") {
            e.hide = false;
            e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
          }
          if (e.name === "thoiGianKetThuc") {
            e.hide = false;
            e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
          }
          if (e.name === "soGioLam") {
            e.hide = false;
            e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          }
          if (e.name === "chamCongTuongUng") {
            e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
            e.hide = false;
          }
          if (e.name === "thoiGianVaoLamTu") {
            e.hide = true;
            e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          }
          if (e.name === "thoiGianVaoLamDen") {
            e.hide = true;
            e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          }
        });
      }
      if (data.loaiCaLam === 1) {
        field.map((e) => {
        if (e.name === "thoiGianBatDau") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = true;
        }
        if (e.name === "thoiGianTinhGioDiMuon") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = true;
        }
        if (e.name === "thoiGianKetThuc") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = true;
        }
        if (e.name === "soGioLam") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = true;
        }
        if (e.name === "chamCongTuongUng") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = false;
        }
        if (e.name === "thoiGianVaoLamTu") {
          e.hide = true;
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "thoiGianVaoLamDen") {
          e.hide = true;
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        }
        });
        
      }
      if (data.loaiCaLam === 2) {
        field.map((e) => {
        if (e.name === "thoiGianBatDau") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = true;
        }
        if (e.name === "thoiGianTinhGioDiMuon") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = true;
        }
        if (e.name === "thoiGianKetThuc") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = true;
        }
        if (e.name === "soGioLam") {
          e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
          e.hide = false;
        } 
        if (e.name === "chamCongTuongUng") {
          e.hide = true;
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "thoiGianVaoLamTu") {
          e.hide = false;
          e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "thoiGianVaoLamDen") {
          e.hide = false;
          e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
        }
        });
        
      }
      setField([...field]);
    }    
  }, [data]);
  useEffect(() => {
    form.setFieldsValue({
      ...data,
      thoiGianBatDau: data?.thoiGianBatDau
        ? dayjs(data.thoiGianBatDau, "HH:mm")
        : null,
      thoiGianKetThuc: data?.thoiGianKetThuc
        ? dayjs(data.thoiGianKetThuc, "HH:mm")
        : null,
      thoiGianTinhGioDiMuon: data?.thoiGianTinhGioDiMuon
        ? dayjs(data.thoiGianTinhGioDiMuon, "HH:mm")
        : null,
        thoiGianVaoLamTu: data?.thoiGianVaoLamTu
        ? dayjs(data.thoiGianVaoLamTu, "HH:mm")
        : null,
        thoiGianVaoLamDen: data?.thoiGianVaoLamDen
        ? dayjs(data.thoiGianVaoLamDen, "HH:mm")
        : null,
        
    });
  }, [data]);
  const onFinish = (values) => {
    if (type == "Thêm") {
      addStore();
      form.resetFields();
    } else {
      updateStore();
    }
  }; 
  function onChangeCheck (value: number) {
    if(value === 0) {
      field.map((e) => {
        if (e.name === "thoiGianBatDau") {
          e.hide = false;
          e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "thoiGianTinhGioDiMuon") {
          e.hide = false;
          e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "thoiGianKetThuc") {
          e.hide = false;
          e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "soGioLam") {
          e.hide = false;
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "chamCongTuongUng") {
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
          e.hide = false;
        }
        if (e.name === "thoiGianVaoLamTu") {
          e.hide = true;
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        }
        if (e.name === "thoiGianVaoLamDen") {
          e.hide = true;
          e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        }
      });
    }
    if (value === 1) {
      field.map((e) => {
      if (e.name === "thoiGianBatDau") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = true;
      }
      if (e.name === "thoiGianTinhGioDiMuon") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = true;
      }
      if (e.name === "thoiGianKetThuc") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = true;
      }
      if (e.name === "soGioLam") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = true;
      }
      if (e.name === "chamCongTuongUng") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = false;
      }
      if (e.name === "thoiGianVaoLamTu") {
        e.hide = true;
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
      }
      if (e.name === "thoiGianVaoLamDen") {
        e.hide = true;
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
      }
      });
      
    }
    if (value === 2) {
      field.map((e) => {
      if (e.name === "thoiGianBatDau") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = true;
      }
      if (e.name === "thoiGianTinhGioDiMuon") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = true;
      }
      if (e.name === "thoiGianKetThuc") {
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
        e.hide = true;
      }
      if (e.name === "soGioLam") {
        e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
        e.hide = false;
      } 
      if (e.name === "chamCongTuongUng") {
        e.hide = true;
        e.rules = [{ required: false, message: `Chưa nhập ${e.label}` }];
      }
      if (e.name === "thoiGianVaoLamTu") {
        e.hide = false;
        e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
      }
      if (e.name === "thoiGianVaoLamDen") {
        e.hide = false;
        e.rules = [{ required: true, message: `Chưa nhập ${e.label}` }];
      }
      });
      
    }
    setField([...field]);
  }

  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 16]}>
              <InputFields
                data={field}
              ></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};

export default ModalAction;
